var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubedark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8929 2.35714C11.8929 1.73199 11.5881 1.13244 11.0456 0.690391C10.503 0.248341 9.76723 0 9 0H2.89286C2.12562 0 1.38981 0.248341 0.847298 0.690391C0.304782 1.13244 0 1.73199 0 2.35714V8.64286C0 9.26801 0.304782 9.86756 0.847298 10.3096C1.38981 10.7517 2.12562 11 2.89286 11H9C9.76723 11 10.503 10.7517 11.0456 10.3096C11.5881 9.86756 11.8929 9.26801 11.8929 8.64286V2.35714ZM12.8571 7.49048L16.0798 9.46C16.8705 9.94348 18 9.48357 18 8.67795V2.32257C18 1.51643 16.8711 1.05652 16.0798 1.54L12.8571 3.50952V7.49048Z",
    fill: "#2d2832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubedark);
export default __webpack_public_path__ + "static/media/youtubedark.47da137961bc5767c51630466ece7a6d.svg";
export { ForwardRef as ReactComponent };